import $ from 'jquery'

export default class Former {
    constructor(form) {
        this.form = form;
    }

    clearErrors() {
        this.form.find('.has-error ').each(function () {
            $(this)
                .removeClass('has-error')
                .find('.error-text').empty().hide();
        });
    }

    bindErrors(errors) {
        const form = this.form;
        $.each(errors, function () {
            if (typeof this.field === 'string' && this.field.length > 0 && typeof this.error === 'string' && this.error.length > 0) {
                const decorator = form.find('[name=' + this.field + ']').closest('.error-decorator');
                decorator
                    .addClass('has-error')
                    .find('.error-text').text(this.error).show();
            }
        });
    }
}
